import { convertFromRaw as draftConvertFromRaw } from 'draft-js';
import _ from 'underscore';

/**
 * Drop entityRanges that reference keys missing from entityMap.
 *
 * Cells can drift out of sync with their entityMap via Mongoose `$set` update
 * paths (see `projects/api/schemas/Item.js` _setDefaultEntityMap for context).
 * Without this guard, Draft.js throws "Unknown DraftEntity key" when the
 * editor mounts to render such a cell.
 */
const sanitizeRteState = (rteState) => {
  const entityMap = rteState.entityMap || {};

  if (!Array.isArray(rteState.blocks)) {
    return _.extend({}, rteState, { entityMap });
  }

  const blocks = rteState.blocks.map((block) => {
    if (!Array.isArray(block.entityRanges)) return block;
    const filtered = block.entityRanges.filter((range) =>
      _.has(entityMap, range.key),
    );
    if (filtered.length === block.entityRanges.length) return block;
    return _.extend({}, block, { entityRanges: filtered });
  });

  return _.extend({}, rteState, { entityMap, blocks });
};

export const convertFromRaw = (rteState) =>
  draftConvertFromRaw(sanitizeRteState(rteState));
